import {
  GET_WORSHIP_LOCATIONS_REQUEST,
  GET_WORSHIP_LOCATIONS_SUCCESS,
  GET_WORSHIP_LOCATION_BY_ID_SUCCESS,
  GET_WORSHIP_LOCATION_BY_ID_REQUEST,
  RESET_WORSHIP_LOCATION_BY_ID_SUCCESS,
} from '../constants/actionTypes';

export const getWorshipLocationsRequest = (payload) => ({
  type: GET_WORSHIP_LOCATIONS_REQUEST,
  payload,
});

export const getWorshipLocationsSuccess = (payload) => ({
  type: GET_WORSHIP_LOCATIONS_SUCCESS,
  payload,
});

export const getWorshipLocationByIdRequest = (payload) => ({
  type: GET_WORSHIP_LOCATION_BY_ID_REQUEST,
  payload,
});

export const getWorshipLocationByIdSuccess = (payload) => ({
  type: GET_WORSHIP_LOCATION_BY_ID_SUCCESS,
  payload,
});

export const resetWorshipLocationByIdSuccess = (payload) => ({
  type: RESET_WORSHIP_LOCATION_BY_ID_SUCCESS,
  payload,
});
